<template>
  <div class="home-delivery">
    <div class="row">
      <form class="col s12">
        <!-- Numéro de téléphone -->
        <phone></phone>

        <!-- Adresse de livraison -->
        <delivery-address></delivery-address>

        <!-- Adresse mail (facultatif) -->
        <mail></mail>

        <!-- Date et heure de livraison -->
        <date-time></date-time>

      </form>
    </div>
  </div>
</template>

<script>
import Phone from '@/components/Basket/Phone.vue'
import DeliveryAddress from '@/components/Basket/Address.vue'
import Mail from '@/components/Basket/Mail.vue'
import DateTime from '@/components/Basket/DateTime.vue'

export default {
  components: { Phone, DeliveryAddress, Mail, DateTime }
};
</script>